module.exports = __webpack_public_path__ + "img/jiso-logo.6623fb65.png";